module.exports = __webpack_public_path__ + "img/btn_back_hover_old.c904d071.png";